export default function ApartmentIcon() {
    return (
        <img src="https://a0.muscache.com/pictures/21cfc7c9-5457-494d-9779-7b0c21d81a25.jpg"
      className="w-8 h-8"
      />
    );
  }
  